import DropdownMenuItem from "ds/components/DropdownMenu/Item";

type AssignRoleFormDeleteActionProps = {
  onDelete: () => void;
};

const AssignRoleFormDeleteAction = ({ onDelete }: AssignRoleFormDeleteActionProps) => {
  return (
    <DropdownMenuItem onAction={onDelete} danger>
      Unassign
    </DropdownMenuItem>
  );
};

export default AssignRoleFormDeleteAction;
